export const environment = {
  production: true,
  app: {
    url: 'https://karpishe.com',
    apiUrl: 'https://karpishe.com/api/',
    assetsUrl: 'https://karpishe.com/data/',
    filesUrl: 'https://karpishe.com/data/files/',
    hubUrl: 'https://karpishe.com/hub/',
    labsUrl: 'https://labs.karpishe.com',
    version: '2026_11_03_14_58',
    env: 'prod',
    shortener: 'https://krp.sh'
  },
  google: {
    recaptcha: {
      enabled: false,
      key: '6LdtpqUUAAAAAIBMo3nqoJFd7qbEhLFLdmEvDUkp'
    },
    map: {
      key: 'AIzaSyCjwpWZomqw-hh69nq1lyeRCPq3MULyTqg'
    }
  },
  banki: {
    apiUrl: 'http://ba.banki.ir/api/'
  },
  firebase: {
    apiKey: "AIzaSyD96gHXjDlJST_9WIEyxuAlVsVpYjt7pP8",
    authDomain: "karpisheh-1562248969341.firebaseapp.com",
    databaseURL: "https://karpisheh-1562248969341.firebaseio.com",
    projectId: "karpisheh-1562248969341",
    storageBucket: "karpisheh-1562248969341.appspot.com",
    messagingSenderId: "482822813007",
    appId: "1:482822813007:web:2171b95f15c6e6ce93413a",
    measurementId: "G-74N892XB89"
  }
};
